<template>
  <div>
    <div class="box">
      <vue-element-loading :active="isLoading" spinner="spinner" />
      <div class="field has-addons has-text-centered is-vcentered">
        <button
          class="mt-1 button is-rounded is-white is-small"
          @click="getPrev()"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
        <button
          class="mt-1 button is-rounded is-white is-small"
          @click="getNext()"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
        <h5 class="title is-5 ml-3 mt-2">
          {{ titleStr.start }} ～ {{ titleStr.end }}
        </h5>
      </div>
      <BarChart v-bind="barChartProps" />
    </div>
  </div>
</template>
<script>
import imsr from "@/imsr-api";
import common from "@/imsr-common";
import { useRoute } from "vue-router";
import { ref, computed } from "vue";
import { Chart, registerables } from "chart.js";
import VueElementLoading from "vue-element-loading";
import { BarChart, useBarChart } from "vue-chart-3";
Chart.register(...registerables);

export default {
  components: {
    VueElementLoading,
    BarChart,
  },
  props: {
    tenantId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const router = useRoute();
    const isLoading = ref(false);
    const baseDate = ref(null);
    const titleStr = ref(null);
    const nextDate = ref();
    const prevDate = ref();
    const data = ref([]);
    const label = ref([]);
    const color = ref(["rgba(54, 162, 235, 0.2)"]);
    const color2 = ref(["rgb(54, 162, 235)"]);

    const chartData = computed(() => ({
      labels: label.value,
      datasets: [
        {
          label: "Count",
          data: data.value,
          borderWidth: 1,
          backgroundColor: color.value,
          borderColor: color2.value,
        },
      ],
    }));

    const options = {
      scales: {
        y: {
          min: 0,
          suggestedMax: 10,
        },
      },
    };

    const { barChartProps, barChartRef } = useBarChart({
      chartData: chartData,
      options,
    });

    const getList = async () => {
      isLoading.value = true;
      try {
        const date = common.makeDate4(baseDate.value);
        titleStr.value = {
          start: date.startStr,
          end: date.endStr,
        };
        nextDate.value = date.nextDate;
        prevDate.value = date.prevDate;
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          startDate: date.startDate,
          endDate: date.endDate,
        };
        const res = await imsr.imsrGetApi("/events/week", params);
        let buf = [];
        label.value = [];
        res.years[0].months[0].weeks.forEach(function(week) {
          label.value.push(week.startDate.replace(/-/g, "/"));
          week.devices.forEach(function(device) {
            if (!buf[week.week]) {
              buf[week.week] = 0;
            }
            buf[week.week] += device.count;
          });
        });
        data.value = [];
        color.value = [];
        color2.value = [];
        buf.forEach(function(element) {
          data.value.push(element);
          if (element >= 30) {
            color.value.push("rgba(255, 99, 132, 0.2)");
            color2.value.push("rgba(255,99,132,1)");
          } else {
            color.value.push("rgba(54, 162, 235, 0.2)");
            color2.value.push("rgb(54, 162, 235)");
          }
        });
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
      isLoading.value = false;
    };
    getList();

    const getPrev = () => {
      baseDate.value = prevDate.value;
      getList();
    };

    const getNext = () => {
      baseDate.value = nextDate.value;
      getList();
    };

    return {
      isLoading,
      nextDate,
      prevDate,
      getPrev,
      getNext,
      chartData,
      titleStr,
      barChartProps,
      barChartRef,
    };
  },
};
</script>
<style>
.has-event {
  padding: 0;
}
</style>
